var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BoardView',{attrs:{"title":"Redaguoti proceso etapą"}},[(_vm.step)?_c('FormValidation',{on:{"submit":_vm.submit}},[_c('FormStep',{attrs:{"step":_vm.step}}),_c('Btn',{attrs:{"type":"submit"}},[_vm._v(" Išsaugoti ")])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }